import { createStore } from "vuex";
import { io } from "socket.io-client";
import en from "./en.json";
import ar from "./ar.json";
//   https://m-neptone.herokuapp.com/ 192.168.1.9:5000

export default createStore({
  state: {
    // Admin store :
    Neptone_version: "2.1.0",
    backend_link: "https://m-neptone.herokuapp.com/",
    socket: io("https://m-neptone.herokuapp.com/", { autoConnect: false }),

    // App tweaks store :
    isNavShown: false,
    connected: 0,
    lang: "en",
    appVocubulary: {
      en,
      ar,
    },

    // Users store :
    user: {
      name: "",
      details: {
        gender: "",
      },
      ...JSON.parse(sessionStorage.getItem("thisNeptoneUser")),
      socketId: "",
      room: "",
    },
    partner: {
      age: "",
      details: {
        gender: "",
        country: "",
      },
    },
  },
  mutations: {
    // User store functions :
    updateUserWith: (state, { updatedProp, newValue }) => {
      state.user[updatedProp] = newValue;
    },
    setupUser: (state, { origin, newData }) => {
      if (origin === "settings") {
        state.user.preferences = newData.preferences;
        state.user.interests = newData.interests;
        state.user.matchAnyone = newData.matchAnyone;
      } else if (origin === "login") {
        state.user = {
          _id: newData._id,
          name: newData.name,
          age: newData.age,
          isAdmin: newData.isAdmin || 0,
          details: {
            gender: newData.gender,
            country: newData.country,
          },
        };
        if (!newData.isAdmin) {
          delete state.user.isAdmin;
        }
      }
      sessionStorage.setItem("thisNeptoneUser", JSON.stringify(state.user));
    },
    updatePartner: (state, partner) => {
      state.partner = partner;
    },

    resetUser: (state) => {
      state.user = {
        name: "",
        details: {
          gender: "",
        },
        ...JSON.parse(sessionStorage.getItem("thisNeptoneUser")),
        id: "",
        room: "",
      };
    },
    // App store functions :
    setConnectedUsers: (state, connected) => {
      state.connected = connected;
    },
    toggleNav: (state, decision) => {
      state.isNavShown = decision;
    },
    increaseByOne: (state, counter) => {
      state[counter]++;
    },
    changeLang: (state, newLang) => {
      state.lang = newLang;
      document.querySelector("html").lang = newLang;
    },
    homeIsVisited: (state) => {
      state.homeVisited = true;
    },
  },
  actions: {},
  modules: {},
});
